import React, { useState, useEffect, useRef } from 'react';

const cardStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '16px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  padding: '24px',
  marginBottom: '24px',
};

const headingStyle = {
  fontSize: '18px',
  fontWeight: 'bold',
  marginBottom: '4px',
  borderBottom: '3px solid #FFD700',
  display: 'inline-block',
  paddingBottom: '4px',
};

const timeStyle = {
  fontSize: '14px',
  color: '#777',
  marginBottom: '16px',
};

const messageStyle = {
  fontSize: '16px',
  color: '#333',
  marginBottom: '16px',
  whiteSpace: 'pre-wrap',
  lineHeight: '1.6',
};

const tipBoxStyle = {
  backgroundColor: '#fffbea',
  borderLeft: '4px solid #FFD700',
  padding: '12px 16px',
  fontSize: '16px',
  fontStyle: 'italic',
  color: '#6b4c00',
  marginTop: '30px',
  marginBottom: '5px',
  borderRadius: '8px',
};

const buttonRowStyle = {
  display: 'flex',
  gap: '12px',
  flexWrap: 'wrap',
  marginTop: '12px',
};

const flickerStyle = {
  animation: 'flicker 0.8s ease-in-out',
};

const primaryButtonStyle = {
  backgroundColor: '#FFD700',
  color: '#000',
  fontSize: '16px',
  fontWeight: '600',
  padding: '12px 24px',
  borderRadius: '12px',
  border: 'none',
  cursor: 'pointer',
  boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
  fontFamily: `'Helvetica Neue', sans-serif`,
};

const utilityButtonStyle = {
  backgroundColor: '#f6f6f6',
  border: 'none',
  borderRadius: '12px',
  padding: '10px 16px',
  fontWeight: '600',
  fontSize: '15px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  cursor: 'pointer',
  fontFamily: `'Helvetica Neue', sans-serif`,
};

const TouchpointCard = ({
  day,
  time,
  channel,
  message,
  coachingTip,
  onRephrase,
  isRephrasing = false,
  onEditSave
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedMessage, setEditedMessage] = useState(message);
  const [justCopied, setJustCopied] = useState(false);

  const textareaRef = useRef(null);

  useEffect(() => {
    if (isEditing && textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
    }
  }, [isEditing, editedMessage]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(message);
    setJustCopied(true);
    setTimeout(() => setJustCopied(false), 1000); // Flicker duration
  };

  return (
    <div style={cardStyle}>
      <div>
        <div style={headingStyle}>📅 Day {day} – {channel}</div>
        <div style={timeStyle}>🕐 Recommended Time: {time}</div>
      </div>

      {isEditing ? (
        <textarea
          ref={textareaRef}
          value={editedMessage}
          onChange={(e) => {
            setEditedMessage(e.target.value);
            if (textareaRef.current) {
              textareaRef.current.style.height = 'auto';
              textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
            }
          }}
          style={{
            width: '95%',
            overflow: 'hidden',
            padding: '14px',
            fontSize: '16px',
            borderRadius: '12px',
            border: '1px solid #ccc',
            backgroundColor: '#f5f5f5',
            boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.06)',
            lineHeight: '1.6',
            minHeight: '120px',
            resize: 'none',
            fontFamily: `'Helvetica Neue', sans-serif`,
          }}
        />
      ) : (
        <div style={messageStyle}>{message}</div>
      )}

      <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
        <button style={utilityButtonStyle} onClick={onRephrase} disabled={isRephrasing}>
          🔁 {isRephrasing ? 'Rephrasing...' : 'Rephrase'}
        </button>
        {!isEditing ? (
          <button style={utilityButtonStyle} onClick={() => setIsEditing(true)}>✏️ Edit</button>
        ) : (
          <button
            style={primaryButtonStyle}
            onClick={() => {
              setIsEditing(false);
              onEditSave(editedMessage);
            }}
          >
            💾 Save
          </button>
        )}
        <button
          style={{
            ...utilityButtonStyle,
            ...(justCopied ? flickerStyle : {})
          }}
          onClick={copyToClipboard}
        >
          {justCopied ? '✅ Copied!' : '📋 Copy'}
        </button>

      </div>

      {coachingTip && (
        <div style={tipBoxStyle}>
          {coachingTip}
        </div>
      )}
    </div>
  );
};

export default TouchpointCard;
